import React from 'react';
import { LogBox } from 'react-native';

import {
  fixAndroidKeyboardLayoutShifts,
  fixIosFullHeightIssue,
  hideStripeSvgLoadingElement,
} from '@order/utils';

import { App } from './App';
import { ErrorBoundary } from './components';
import { UrqlProvider } from './context/Urql';
import { addSnapPixelScript, loadOneTrust } from './integrations';
import { initDatadog, notifee } from './integrations';
import { intlPolyfill } from './polyfills';
import { Providers } from './Providers';

// ─────────────────────────────────────────────────────────────────────────────

// FIXME we need to fix the underlying issue for Android; this is here so that Android e2e tests can pass.
// The warning it is hiding is covering UI elements the test runner is trying to interact with.
LogBox.ignoreAllLogs();

addSnapPixelScript();
intlPolyfill();
void initDatadog();
fixAndroidKeyboardLayoutShifts();
fixIosFullHeightIssue();
loadOneTrust();
hideStripeSvgLoadingElement();

// ─── Notifications ───────────────────────────────────────────────────────────

void notifee?.requestPermission();

// ─────────────────────────────────────────────────────────────────────────────

export const Root = () => (
  <ErrorBoundary>
    <UrqlProvider>
      <Providers>
        <App />
      </Providers>
    </UrqlProvider>
  </ErrorBoundary>
);
